import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1339b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "online-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "delete-indicator"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-2" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { ProfileAvatarSizeEnum } from "../../types/avatar";

interface ProfileAvatarProps {
  size?: ProfileAvatarSizeEnum;
  src: string;
  isOnline?: boolean;
  isDelete?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileAvatar',
  props: {
    size: { default: ProfileAvatarSizeEnum.Small },
    src: { default: "" },
    isOnline: { type: Boolean, default: false },
    isDelete: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["img-container", _ctx.size])
  }, [
    _createElementVNode("img", {
      src: _ctx.src,
      alt: "profile avatar"
    }, null, 8, _hoisted_1),
    (_ctx.isOnline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.isDelete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}
}

})